import * as screens from "./chat-screens"
import { Routes, Route, Navigate } from "react-router-dom";

const ChatNavigation = () => {

  return (
    <Routes>
      <Route path="/" element={<screens.ChatScreen />}/>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

export default ChatNavigation